import createElement from '../logical-components/createElement';
var generatePapers = function (data) {
    var _a;
    if ((_a = data === null || data === void 0 ? void 0 : data.titles) === null || _a === void 0 ? void 0 : _a.length) {
        var DOM = createElement('div');
        var wrapper_1 = createElement('div', [
            { type: 'class', value: '_mnslq-card-papers' },
        ]);
        data.titles.forEach(function (paper) {
            wrapper_1.innerHTML += "<span> ".concat(paper, " </span>");
        });
        // Pass the template back as a string
        DOM.appendChild(wrapper_1);
        return DOM.innerHTML;
    }
    return '';
};
export default generatePapers;
